import { memo, useCallback, useMemo } from 'react';
import {
  claimStatusReward,
  selectIsClaimingReward,
} from '../state/status.slice';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import { Box, Button, Text } from '@betty/moonlight';
import { statusTextTokenMap } from '../content/status.content';
import { useTranslation } from '@betty/i18n';
import { StatusBoxListItemProps } from './types';
import StatusBoxWithGem from './StatusBoxWithGem';

function StatusBoxListItem({ reward, isOnlyItem }: StatusBoxListItemProps) {
  const dispatch = useDispatch();
  const isClaimingReward = useSelector((state) =>
    selectIsClaimingReward(state, reward.rewardId),
  );

  const handleOpen = useCallback(async () => {
    await dispatch(claimStatusReward(reward.rewardId));
    // TODO: Animate coins
  }, [dispatch, reward]);

  const [t] = useTranslation('status');

  const GiftBoxText = useMemo(
    () =>
      isOnlyItem ? null : (
        <Text
          variant="body-s-semi"
          gradient={statusTextTokenMap[reward.sourceType]}
        >
          {t('status_box_list_item_name', { status: reward.sourceType })}
        </Text>
      ),
    [reward, isOnlyItem, t],
  );

  return (
    <Box
      width="100%"
      flexDirection={isOnlyItem ? 'column' : 'row'}
      gap={isOnlyItem ? 'space-500' : 'space-0'}
      justifyContent="space-between"
      alignItems="center"
    >
      <Box flexDirection="row" gap="space-200" alignItems="center">
        <StatusBoxWithGem
          isOnlyItem={isOnlyItem}
          statusName={reward.sourceType}
        />
        {GiftBoxText}
      </Box>
      <Button
        width={isOnlyItem ? '100%' : 'auto'}
        minWidth={85}
        variant={isOnlyItem ? 'primary' : 'secondary'}
        locNS="status"
        locKey="status_boxes_open_cta"
        onPress={handleOpen}
        loading={isClaimingReward}
      />
    </Box>
  );
}

export default memo(StatusBoxListItem);
